namespace Assets {

	interface IButtons {
		button: PIXI.Texture;
		arrow: PIXI.Texture;
		armageddon: PIXI.Texture;
		electro: PIXI.Texture;
		atomic: PIXI.Texture;
		what: PIXI.Texture;
		buttonOver: PIXI.Texture;
		buttonDown: PIXI.Texture;

		cost: PIXI.Texture;
		panel_hp: PIXI.Texture;
		panel_top: PIXI.Texture;
		panel_square: PIXI.Texture;
		panel_small: PIXI.Texture;

		upgrade: PIXI.Texture;
		repair: PIXI.Texture;

		money_icon: PIXI.Texture;
		rabbit_icon: PIXI.Texture;
		bear_icon: PIXI.Texture;
		pony_icon: PIXI.Texture;
		kps_icon: PIXI.Texture;
	}

	export const loader = new PIXI.loaders.Loader("img/");

	export let tex1: PIXI.Texture;

	export let allMonsters: Array<IBunnyDesc> = [];

	export let allBullets: Array<BulletDesc> = [];

	export let allTowers: Array<TowerDesc> = [];

	export let boomAnim: Array<PIXI.Texture> = [];

	export let bg: PIXI.Texture;

	export let slot: PIXI.Texture;

	export let ui: IButtons;

	let ignoreLoad = false;

	export function preload(callback: () => void) {
		if (ignoreLoad) {
			callback();
			return;
		}
		ignoreLoad = true;

		loader.add('monsters', 'enemies/sprites.json');
		loader.add('towers', 'towers/sprites.json');
		loader.add('boom', 'boom/sprites.json');
		loader.add('bg', 'towers.png');
		loader.add('slot', 'slot.png');
		loader.add('buttons', 'buttons/sprites.json');

		loader.load((loader: any, resources: { [key: string]: PIXI.loaders.Resource }) => {

			// FILL UP DICTIONARIES AND TEXTURES!

			const monsters = filterKeys(resources['monsters'].textures);

			allMonsters.push({
				cutieTex: monsters['hare_0'],
				jumpTex: monsters['hare_1'],
				shadowTex: monsters['hare_0_sh'],
				corpses: [monsters['blood_hare']],
			});

			allMonsters.push({
				cutieTex: monsters['teddy_0'],
				jumpTex: monsters['teddy_1'],
				shadowTex: monsters['teddy_0_sh'],
				corpses: [monsters['blood_teddy']],
				corpseFrames: 180,
				zIndex: 1,
			});

			allMonsters.push({
				cutieTex: monsters['pony_armor_0'],
				jumpTex: monsters['pony_armor_1'],
				shadowTex: monsters['pony_armor_0_sh'],
				shadowJumpTex: monsters['pony_armor_1_sh'],
				corpses: [monsters['blood_pony']],
				corpseFrames: 600,
				zIndex: 2,
			});

			allMonsters.push({
				cutieTex: monsters['pony_0'],
				jumpTex: monsters['pony_1'],
				shadowTex: monsters['pony_0_sh'],
				shadowJumpTex: monsters['pony_1_sh'],
				corpses: [monsters['blood_pony']],
				corpseFrames: 600,
				zIndex: 2,
			});

			allMonsters.push({
				cutieTex: monsters['pony_bone_0'],
				jumpTex: monsters['pony_bone_1'],
				shadowTex: monsters['pony_bone_0_sh'],
				shadowJumpTex: monsters['pony_bone_1_sh'],
				corpses: [monsters['blood_pony']],
				corpseFrames: 600,
				zIndex: 2,
			});

			const towers = filterKeys(resources['towers'].textures);

			allTowers.push({
				baseTex: towers['tower_base'],
				turretTex: towers['barricade'],
			});

			allTowers.push({
				baseTex: towers['tower_base'],
				trunkTex: towers['lasergun_trunk'],
				turretTex: towers['lasergun_turret'],
				trunks: [2, -2]
			});

			allTowers.push({
				baseTex: towers['tower_base'],
				trunkTex: towers['lasergun_trunk'],
				turretTex: towers['lasergun_turret_2trunks'],
				trunks: [0, 8, 0, -13]
			});

			allTowers.push({
				baseTex: towers['tower_base'],
				trunkTex: towers['lasergun_trunk'],
				turretTex: towers['lasergun_turret_sniper'],
				trunks: [-6, 0],
				bulletNumber: 1,
				bulletScale: 2,
			});

			allTowers.push({
				baseTex: towers['tower_base'],
				turretTex: towers['mortar_open'],
				bulletNumber: 2,
				bulletSpeed: 10,
				bulletTargeting: true
			});

			allBullets.push({
				bulletTex: towers['lasershot']
			});

			allBullets.push({
				bulletTex: towers['lasershot_sniper']
			});

			allBullets.push({
				bulletTex: towers['mortarshot']
			});


			boomAnim = extractAnim(resources['boom'].textures, "smoke_export_2_", 10000, 10100);

			ui = filterKeys(resources['buttons'].textures);

			bg = resources['bg'].texture;

			slot = resources['slot'].texture;

			callback();
		});
	}

	function extractAnim(tex: any, prefix: string, start: number, end: number): Array<PIXI.Texture> {
		const res: Array<PIXI.Texture> = [];
		for (let i = start; i < end; i++) {
			const s = i.toString().substr(1) + ".png";
			if (tex[prefix + s]) {
				res.push(tex[prefix + s]);
			}
		}
		return res;
	}

	function filterKeys(obj: any, renames?: any): any {
		let res: any = {};
		for (let key in obj) {
			res[key.replace('.png', '')] = obj[key];
		}

		if (renames) {
			for (let key in renames) {
				let val = renames[key];
				if (res[val]) res[key] = res[val];
			}
		}

		return res;
	}
}
